import type { VertexAttribute } from '../../../../types'
import { createIndexBufferUint32, updateAttributeBuffer } from '../../../../utils'

export const updateBuffers = (
  renderingContext: WebGL2RenderingContext,
  positionsAttribute: VertexAttribute,
  vertices: Float32Array,
  indexes: Uint32Array,
) => {
  const indexesCount = indexes.length
  updateAttributeBuffer(renderingContext, positionsAttribute, new Float32Array(vertices))
  const indexBuffer = createIndexBufferUint32(renderingContext, indexes)

  return { indexBuffer, indexesCount }
}
